import React, { useState, useEffect } from 'react';

const TransUnionReportModal3 = ({
  isOpen,
  onClose,
  CreditReportData,
   Equifaxv2Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
  cusName,
  mobile,
  gender,
  panNo,
}) => {
  const [isPrinting, setIsPrinting] = useState(false);

    useEffect(() => {
     // console.log("data",Equifaxv2Error);
    }, [CreditReportData], [Equifaxv2Error]);

     if (!isOpen) return null;

  
//  Updated check - handles your exact 400 response
const hasNoReportData = !CreditReportData || 
  Object.keys(CreditReportData).length === 0 ||
  CreditReportData.status === 400 ||  //  Your exact error status
  (Array.isArray(CreditReportData.data) && CreditReportData.data.length === 0) || //  data: []
  CreditReportData.status?.code === 500 ||
  Equifaxv2Error?.status === 400;


  // Extract error message from Equifaxv2Error
  const errorMessage = Equifaxv2Error?.message || 
    Equifaxv2Error?.status?.message || 
    Equifaxv2Error?.status?.type || 
    'No credit history found';


  // Extract data dynamically
  // const creditReport = CreditReportData?.data?.GetCustomerAssetsResponse
  //   ?.GetCustomerAssetsSuccess?.Asset?.TrueLinkCreditReport || 
  //   CreditReportData?.data?.cibilData?.GetCustomerAssetsResponse
  //   ?.GetCustomerAssetsSuccess?.Asset?.TrueLinkCreditReport  ||
  //   {};

  const normalizeArray = (data) => {
  if (!data) return [];

  // already array
  if (Array.isArray(data)) return data;

  // object with Tradeline array
  if (Array.isArray(data.Tradeline)) {
    return data.Tradeline.map((t) => ({ Tradeline: t }));
  }

  // object with single Tradeline
  if (data.Tradeline) {
    return [{ Tradeline: data.Tradeline }];
  }

  // single object
  return [data];
};


// More robust path with logging
const creditReport = CreditReportData?.data?.GetCustomerAssetsResponse
  ?.GetCustomerAssetsSuccess?.Asset?.TrueLinkCreditReport || 
  CreditReportData?.data?.cibilData?.GetCustomerAssetsResponse
  ?.GetCustomerAssetsSuccess?.Asset?.TrueLinkCreditReport || {};


  const borrower = creditReport?.Borrower || {};
  const creditStatements = creditReport?.Borrower?.CreditStatement || {};
 const tradeLinePartitions = normalizeArray(creditReport?.TradeLinePartition);
  const inquiryPartitions = creditReport?.InquiryPartition || [];
  const sources = creditReport?.Sources?.Source || {};
  const message = creditReport?.Message || {};


  // ============================================
  // HELPER FUNCTIONS
  // ============================================

  const formatKey = (key) => {
    if (!key) return '';
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
      .trim();
  };


  const formatValue = (key, value) => {
  if (value === null || value === undefined || value === '' || value === '-1' || value === 'NA') {
    return 'N/A';
  }

  const keyLower = String(key).toLowerCase();

  // Handle objects FIRST (before other checks) ⭐
  if (typeof value === 'object' && value !== null) {
    // Check for symbol first (most specific)
    if (value.symbol && value.symbol !== '') return value.symbol;
    // Then check description
    if (value.description && value.description !== '') return value.description;
    // If both are empty, return N/A instead of showing the object
    return 'N/A';
  }

  // Amount formatting
  if (keyLower.includes('amount') || keyLower.includes('balance') || keyLower.includes('credit') || keyLower.includes('limit')) {
    if (!isNaN(value) && value !== '-1') {
      return `₹${parseFloat(value).toLocaleString('en-IN')}`;
    }
  }

  // Rate formatting
  if (keyLower.includes('rate') && !isNaN(value) && value !== '-1') {
    return `${value}%`;
  }

  // Date formatting
  if (keyLower.includes('date') && value.includes && value.includes('+')) {
    return value.split('+')[0];
  }
  return value;
};



          const buildYearlyHistory = (monthlyPayStatusRaw) => {
  const months = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
  const history = {};

  // Normalize to array
  const monthlyPayStatus = Array.isArray(monthlyPayStatusRaw)
    ? monthlyPayStatusRaw
    : monthlyPayStatusRaw
    ? [monthlyPayStatusRaw]
    : [];

  monthlyPayStatus.forEach((item) => {
    if (!item?.date) return;

    const dateStr = item.date.split('+')[0].split('T')[0];
    const date = new Date(dateStr + 'T00:00:00');

    if (isNaN(date.getTime())) return;

    const year = date.getFullYear();
    const monthIndex = date.getMonth();

    if (!history[year]) {
      history[year] = Array(12).fill("-");
    }

    history[year][monthIndex] = item.status ?? "000";
  });

  return { months, history };
};



  const getStatusColor = (status) => {
  // Handle empty
  if (status === '-') return 'text-gray-400';
  
  // Handle string status codes (CIBIL format)
  const statusUpper = String(status).toUpperCase();
  
  // Not reported / No data
  if (statusUpper === 'XXX' || statusUpper === '000' || status === '000') {
    return 'text-gray-500';
  }
  
  // Standard - On time payment
  if (statusUpper === 'STD' || ['22', '24', '25'].includes(String(status))) {
    return 'text-green-700 font-semibold';
  }
  
  // Past Due - 30 days
  if (statusUpper === '030' || statusUpper === 'SMA') {
    return 'text-yellow-500 font-bold';
  }
  
  // Past Due - 60 days
  if (statusUpper === '060') {
    return 'text-orange-500 font-bold';
  }
  
  // Past Due - 90+ days / Default
  if (statusUpper === '090' || statusUpper === 'SUB' || 
      statusUpper === 'DBT' || statusUpper === 'LSS' || 
      statusUpper === 'DPD' || ['47', '55'].includes(String(status))) {
    return 'text-red-600 font-bold';
  }
  
  // Special situations
  if (statusUpper === 'NEW') return 'text-blue-500 font-semibold';
  if (status === '32') return 'text-yellow-600 font-bold';
  
  // Default for unknown codes
  return 'text-gray-600';
};



  const renderDynamicObject = (obj, excludeKeys = []) => {
    if (!obj || typeof obj !== 'object') return null;

    return Object.entries(obj)
      .filter(([key]) => !excludeKeys.includes(key))
      .map(([key, value]) => {
        const formattedValue = formatValue(key, value);
        if (formattedValue === 'N/A') return null;

        return (
          <div key={key} className="border p-2">
            <p className="text-[10px] textpx">
              <span className="font-semibold text-cyan-500 cibil-cyan uppercase">
                {formatKey(key)}:
              </span>
              <span className="ml-2 text-black font-medium normal-case">
                {formattedValue}
              </span>
            </p>
          </div>
        );
      })
      .filter(Boolean);
  };




  const printReport = () => {
  setIsPrinting(true);

  const printWindow = window.open('about:blank', '_blank', 'height=700,width=1000');
  const printContents = document.getElementById("reportdata").innerHTML;

  printWindow.document.write(`
    <html>
      <head>
        <title>TransUnion Report</title>
        <link 
          href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" 
          rel="stylesheet"
          id="tailwind-cdn"
        >
        <style>
          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            .cibil-cyan {
              color: #00acd7 !important;
            }
            .cibil-yellow-bg {
              background-color: #f8d406 !important;
            }
            .textpx {
              font-size: 11px !important;
            }
          }
        </style>
      </head>
      <body>${printContents}</body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();

  // Wait for stylesheet to load
  const link = printWindow.document.getElementById('tailwind-cdn');
  
  link.onload = () => {
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
      setIsPrinting(false);
    }, 500);
  };

  // Fallback if CDN fails
  link.onerror = () => {
    alert('Stylesheet failed to load. Please try again.');
    printWindow.close();
    setIsPrinting(false);
  };
};



// Get all unique keys from borrower for dynamic rendering
const getBorrowerKeys = () => {
  const keys = [];

  // Add basic fields - SAFE checks
  if (borrower?.BorrowerName?.Name) {
    const fullName = `${borrower.BorrowerName.Name.Forename || ''} ${borrower.BorrowerName.Name.Surname || ''}`.trim();
    if (fullName) {
      keys.push({ key: 'name', value: fullName });
    }
  }

  if (borrower?.Gender) keys.push({ key: 'Gender', value: borrower.Gender });
  
  if (borrower?.Birth?.date) keys.push({ key: 'dateOfBirth', value: borrower.Birth.date });
  if (borrower?.Birth?.age) keys.push({ key: 'age', value: borrower.Birth.age });

  // Add identifiers - SAFE array check
  const identifiers = borrower?.IdentifierPartition?.Identifier;
  if (Array.isArray(identifiers)) {
    identifiers.forEach(id => {
      if (id?.ID?.Id && id?.ID?.IdentifierName) {
        keys.push({ 
          key: id.ID.IdentifierName, 
          value: id.ID.Id 
        });
      }
    });
  }

  // Add phones - ✅ FIXED: Safe array + slice
  const phones = borrower?.BorrowerTelephone;
  if (Array.isArray(phones)) {
    phones.slice(0, 2).forEach((phone, idx) => {
      if (phone?.PhoneNumber?.Number) {
        keys.push({ 
          key: `telephone${idx + 1}`, 
          value: phone.PhoneNumber.Number 
        });
      }
    });
  } else if (phones?.PhoneNumber?.Number) {
    // ✅ Fallback: single phone object (not array)
    keys.push({ 
      key: 'telephone1', 
      value: phones.PhoneNumber.Number 
    });
  }

  return keys;
};




// Get dynamic keys for tradeline sections - FUTURE-PROOF & SAFE
const getTradelineKeys = (tradeline) => {
  // ✅ Early return for null/undefined
  if (!tradeline || typeof tradeline !== 'object') {
    return { accountKeys: [], amountKeys: [], statusKeys: [] };
  }

  const accountKeys = [];
  const amountKeys = [];
  const statusKeys = [];

  const excludeKeys = [
    'GrantedTrade', 'Source', 'accountTypeAbbreviation', 
    'accountTypeDescription', 'accountTypeSymbol', 'Tradeline',
    'DisputeFlag', 'PayStatus', 'AccountDesignator', 'AccountCondition',
    'OpenClosed', 'VerificationIndicator', 'IndustryCode'
  ];

  // ✅ 1. Main tradeline fields - SAFE
  Object.entries(tradeline).forEach(([key, value]) => {
    if (excludeKeys.includes(key)) return;

    const formattedValue = formatValue(key, value);
    if (!formattedValue || formattedValue === 'N/A') return; // Skip empty

    const keyLower = key.toLowerCase();
    
    // ✅ FUTURE-PROOF: Auto-categorize ANY new fields
    if (isAmountField(keyLower)) {
      amountKeys.push({ key, value: formattedValue });
    } else if (isStatusField(keyLower)) {
      statusKeys.push({ key, value: formattedValue });
    } else {
      accountKeys.push({ key, value: formattedValue });
    }
  });

  // ✅ 2. GrantedTrade nested - SAFE & FUTURE-PROOF
  const grantedTrade = tradeline.GrantedTrade;
  if (grantedTrade && typeof grantedTrade === 'object') {
    Object.entries(grantedTrade).forEach(([key, value]) => {
      if (key === 'PayStatusHistory' || key === 'Source') return;

      const formattedValue = formatValue(key, value);
      if (!formattedValue || formattedValue === 'N/A') return;

      const keyLower = key.toLowerCase();
      
      // ✅ Prefix for nested + auto-categorize
      const displayKey = `GrantedTrade.${key}`;
      
      if (isAmountField(keyLower)) {
        amountKeys.push({ key: displayKey, value: formattedValue });
      } else if (isStatusField(keyLower)) {
        statusKeys.push({ key: displayKey, value: formattedValue });
      } else {
        accountKeys.push({ key: displayKey, value: formattedValue });
      }
    });
  }

  return { accountKeys, amountKeys, statusKeys };
};

// ✅ HELPER: Auto-detect amount fields (future-proof)
const isAmountField = (keyLower) => {
  return keyLower.includes('amount') || keyLower.includes('balance') || 
         keyLower.includes('limit') || keyLower.includes('credit') ||
         keyLower.includes('emi') || keyLower.includes('due') || keyLower.includes('overdue');
};

// ✅ HELPER: Auto-detect status fields (future-proof)
const isStatusField = (keyLower) => {
  return keyLower.includes('date') || keyLower.includes('status') ||
         keyLower.includes('frequency') || keyLower.includes('rate') ||
         keyLower.includes('term') || keyLower.includes('paid') || keyLower.includes('installment');
};




// Add this helper function before your component return - FUTURE-PROOF
const getConsumerName = () => {
  // ✅ 1. TransUnion: Name array
  if (CreditReportData?.Name && Array.isArray(CreditReportData.Name) && CreditReportData.Name.length > 0) {
    const nameObj = CreditReportData.Name[0];
    const firstName = nameObj.firstName || nameObj.Forename || '';
    const middleName = nameObj.middleName || '';
    const surname = nameObj.surname || nameObj.lastName || nameObj.Surname || '';
    return `${firstName} ${middleName} ${surname}`.trim() || 'N/A';
  }
  
  // ✅ 2. consumerIdentity.name array (Equifax/CRIF)
  if (CreditReportData?.consumerIdentity?.name && Array.isArray(CreditReportData.consumerIdentity.name)) {
    const nameObj = CreditReportData.consumerIdentity.name[0];
    const firstName = nameObj.firstName || nameObj.Forename || '';
    const surname = nameObj.surname || nameObj.lastName || nameObj.Surname || '';
    return `${firstName} ${surname}`.trim() || 'N/A';
  }
  
  // ✅ 3. Borrower nested (TransUnion/CRIF common)
  if (CreditReportData?.borrower?.BorrowerName?.Name) {
    const borrowerName = CreditReportData.borrower.BorrowerName.Name;
    const firstName = borrowerName.Forename || borrowerName.firstName || '';
    const surname = borrowerName.Surname || borrowerName.surname || borrowerName.lastName || '';
    return `${firstName} ${surname}`.trim() || 'N/A';
  }
  
  // ✅ 4. Direct fields (CIBIL/Experian)
  const directNames = [
    'name', 'fullName', 'consumerName', 'BorrowerName',
    'consumer_identity_name', 'personalInfo.name'
  ];
  for (const field of directNames) {
    const value = getNestedValue(CreditReportData, field.split('.'));
    if (value) return value;
  }
  
  // ✅ 5. Fallback: getBorrowerKeys (your existing logic)
  const borrowerKeys = getBorrowerKeys();
  const nameKey = borrowerKeys.find(item => {
    const keyLower = item.key.toLowerCase();
    return keyLower.includes('name') && 
           !keyLower.includes('creditor') && 
           !keyLower.includes('account') &&
           item.value && item.value !== 'N/A';
  });
  if (nameKey?.value) return nameKey.value;
  
  // ✅ 6. Ultimate fallback: Request data (error case)
  if (Equifaxv2Error?.request?.name) {
    return Equifaxv2Error.request.name;
  }
  
  return 'N/A';
};

// ✅ HELPER: Safe nested property access
const getNestedValue = (obj, path) => {
  try {
    return path.reduce((current, key) => current?.[key], obj);
  } catch {
    return null;
  }
};


// Safely get nested property with fallback
const get = (obj, path, defaultValue = 'N/A') => {
  return path.split('.').reduce((current, key) => current?.[key], obj) ?? defaultValue;
};

// Handle both array and single object formats
const getAllInquiries = (data) => {
  if (!data) return [];
  
  // If array, return as-is
  if (Array.isArray(data)) {
    return data.filter(partition => partition?.Inquiry).map(partition => partition.Inquiry);
  }
  
  // If single object with Inquiry property
  if (data.Inquiry) {
    return [data.Inquiry];
  }
  
  // If direct Inquiry object
  if (data.inquiryDate || data.subscriberName) {
    return [data];
  }
  
  return [];
};

// Count inquiries safely
const getInquiryCount = (data) => {
  const inquiries = getAllInquiries(data);
  return inquiries.length;
};

// Check if has inquiries
const hasInquiries = (data) => {
  return getInquiryCount(data) > 0;
};

// Get primary inquiry date (handles both formats)
const getInquiryDate = (inquiry) => {
  return inquiry?.inquiryDate || inquiry?.Source?.InquiryDate || '';
};


  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-1">
      <div className="bg-white rounded-lg shadow-lg w-full md:max-w-4xl overflow-y-auto max-h-[100vh]" id="reportdata">

        {/* ERROR MESSAGE BLOCK */}
        {/* {displayMessageBlock && (() => {
          const errorMsg = reportMessage || message?.text || '';
          const errorCode = reportCode || message?.Code?.symbol || '';
          const isSuccess = /success|sucess/i.test(errorMsg);

          if (isSuccess || (!errorMsg && !errorCode)) return null;

          return (
            <div className="flex flex-col items-center justify-center my-2 px-4">
              <div className="bg-red-50 border border-red-400 rounded-md p-3 w-full md:w-3/4">
                {errorMsg && (
                  <p className="text-center text-black font-bold">
                    {formatKey('error')}: <span className="font-normal">{formatKey(errorMsg)}</span>
                  </p>
                )}
                {errorCode && (
                  <p className="text-center text-black font-bold mt-1">
                    {formatKey('code')}: <span className="font-normal">{errorCode}</span>
                  </p>
                )}
              </div>
            </div>
          );
        })()} */}






        {/* HEADER SECTION - Fully Dynamic */}
        <div className="w-full px-2">
          <div className="grid grid-cols-12 items-center mt-2">
            <div className="col-span-9 flex flex-wrap items-center text-[10px] gap-x-2">
              {Object.entries({
                ReferenceKey: creditReport?.ReferenceKey,
                InquiryDate: sources?.InquiryDate,
                Bureau: sources?.Bureau?.symbol,
                currentversion: creditReport?.currentversion
              }).map(([key, value]) => {
                if (!value) return null;
                return (
                  <React.Fragment key={key}>
                    <span className="font-semibold cibil-cyan text-cyan-500">{formatKey(key)}:</span>
                    <span className="ml-1">{formatValue(key, value)}</span>
                    <span className="text-gray-500">|</span>
                  </React.Fragment>
                );
              })}
            </div>

            <div className="col-span-3 flex justify-end">
              <img
                src="https://imgs.search.brave.com/PS09ni7k-MWeOfPvQ0sD4xlRP7Myn_oTAu2Kf3jFHqs/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pLnRy/YWN4bi5jb20vbG9n/by9jb21wYW55L1Nj/cmVlbnNob3RfM185/Zjc4YzYwZS1mNjg1/LTQ4ZjItYTNhOC02/OTIyOTU4YjZiYTYu/cG5nP2Zvcm1hdD13/ZWJwJmhlaWdodD0x/MjAmd2lkdGg9MTIw"
                className="w-32"
                alt={formatKey('logo')}
              />
            </div>
          </div>
          <div className="bg-yellow-400 h-1 w-[80%] mt-[-8px]"></div>
        </div>

      {hasNoReportData && displayMessageBlock && (
          <div className="error-message-block p-6 bg-red-50 border border-red-200 rounded-lg">
            <div className="text-center">
              <h3 className="text-red-800 font-bold text-xl mb-4">
                No Credit History Found
              </h3>
              <p className="text-red-600 mb-2">
                {errorMessage}
              </p>
              {Equifaxv2Error?.status?.code && (
                <p className="text-sm text-red-500 bg-red-100 px-3 py-1 rounded-full inline-block">
                  Error Code: {Equifaxv2Error?.status?.code}
                </p>
              )}
             
            </div>
          </div>
        )}
   
          <div className="p-1">
      
      {/* BORROWER QUICK INFO - Fully Dynamic */}
<div className="mb-4">
  <p className="font-semibold text-black text-sm mb-2">{formatKey('consumerInformation')}</p>
  
  <div className="border border-gray-300 rounded-md overflow-hidden">
    {hasNoReportData ? (
      /*  NO DATA: Show request details from error response */
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 p-4 bg-gray-50">
        {[
          { key: 'name', label: 'Name', value: Equifaxv2Error?.request?.name || cusName || 'N/A' },
          { key: 'mobile', label: 'Mobile', value: Equifaxv2Error?.request?.mobile || mobile || 'N/A' },
          { key: 'pan_card', label: 'PAN Card', value: Equifaxv2Error?.request?.pan_card || panNo || 'N/A' },
          { key: 'gender', label: 'Gender', value: Equifaxv2Error?.request?.gender || gender || 'N/A' },
          { key: 'report_type', label: 'Report Type', value: Equifaxv2Error?.request?.report_type?.toUpperCase() || 'N/A' },
        ].map(({ key, label, value }) => (
          <div key={key} className="border border-gray-200 p-3 bg-white rounded">
            <p className="text-[10px]">
              <span className="font-semibold text-cyan-500 cibil-cyan uppercase">
                {label}:
              </span>
              <span className="ml-2 text-black font-medium normal-case block mt-1">
                {value}
              </span>
            </p>
          </div>
        ))}
        {/* Error message */}
        {/* {Equifaxv2Error?.message && (
          <div className="col-span-full p-3 bg-red-50 border border-red-200 rounded mt-2">
            <p className="text-xs text-red-700 font-medium">
              {Equifaxv2Error.message}
            </p>
            <p className="text-xs text-red-500 mt-1">
              Request ID: {Equifaxv2Error?.request_uid || 'N/A'}
            </p>
          </div>
        )} */}
      </div>
    ) : (
      /*  HAS DATA: Original borrower info */
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-0">
        {getBorrowerKeys().map(({ key, value }) => (
          <div key={key} className="border p-2 hover:bg-gray-50 transition-colors">
            <p className="text-[10px]">
              <span className="font-semibold text-cyan-500 cibil-cyan uppercase">
                {formatKey(key)}:
              </span>
              <span className="ml-2 text-black font-medium normal-case">
                {formatValue(key, value)}
              </span>
            </p>
          </div>
        ))}
      </div>
    )}
  </div>
</div>


            {/* CREDIT SCORE - Dynamic */}
            <div className="md:text-black p-1 text-black mt-2 rounded-tr-md rounded-tl-md text-xs border">
              {formatKey('creditScore').toUpperCase()}
            </div>

            <div className="border p-2 flex flex-row md:flex-row items-center justify-around gap-2">
              <div className="flex flex-col items-center bg-green-300 rounded-lg border-green-700 border p-2 w-32">
                <span className="text-4xl font-bold text-blue-900">
                  {borrower?.CreditScore?.riskScore || 'N/A'}
                </span>
                <span className="text-xs font-semibold text-cyan-600 mt-1">
                  {formatKey(borrower?.CreditScore?.scoreName || 'score')}
                </span>
              </div>

              <div className="text-sm space-y-1">
                {Object.entries({
                  populationRank: borrower?.CreditScore?.populationRank,
                  scoreModel: borrower?.CreditScore?.CreditScoreModel?.symbol,
                  borrowerKey: borrower?.borrowerKey
                }).map(([key, value]) => {
                  if (!value) return null;
                  return (
                    <p key={key}>
                      <span className="font-semibold text-cyan-500">{formatKey(key)}:</span>{' '}
                      <span className="text-black">{value}</span>
                    </p>
                  );
                })}
              </div>
            </div>




        
<div className="p-1 mb-4">
  <div className="text-black mb-2">
    <h3 className="font-bold text-lg">{formatKey('creditStatements')}</h3>
    <p className="text-xs text-gray-600">
      {formatKey('totalStatements')}: {Array.isArray(creditStatements) ? creditStatements.length : 1}
    </p>
  </div>

  {creditStatements ? (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto text-left border-collapse text-[10px] whitespace-nowrap">
        <thead className=" sticky top-0">
          <tr>
            <th className="border px-2 py-1 text-cyan-600 font-semibold">#</th>
            {['type', 'description', 'statementText', 'sourceDate', 'bureau', 'lastUpdated'].map(header => (
              <th key={header} className="border px-2 py-1 text-cyan-600 font-semibold">
                {formatKey(header)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(creditStatements) ? (
            creditStatements.map((statement, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? 'bg-orange-50 hover:bg-orange-100' : 'bg-white hover:bg-orange-50'}>
                <td className="border px-2 py-1 text-center font-semibold text-xs">{idx + 1}</td>
                
                {/* StatementType */}
                <td className="border px-2 py-1 font-semibold text-orange-700 text-xs">
                  {statement.StatementType?.symbol || 'N/A'}
                </td>
                
                {/* StatementType description */}
                <td className="border px-2 py-1 text-xs">
                  {statement.StatementType?.description || 'N/A'}
                </td>
                
                {/* statement text */}
                <td className="border px-2 py-1 font-medium text-xs italic bg-yellow-50 max-w-[120px]">
                  {statement.statement || 'No text'}
                </td>
                
                {/* Source.InquiryDate */}
                <td className="border px-2 py-1 text-xs text-gray-600">
                  {formatValue('date', statement.Source?.InquiryDate)}
                </td>
                
                {/* Source.Bureau */}
                <td className="border px-2 py-1 text-xs">
                  {statement.Source?.Bureau?.symbol || 'N/A'}
                </td>
                
                {/* dateUpdated */}
                <td className="border px-2 py-1 text-xs text-gray-500">
                  {formatValue('date', statement.dateUpdated) || 'N/A'}
                </td>
              </tr>
            ))
          ) : (
            // Single object case
            <tr className="bg-orange-50">
              <td className="border px-2 py-1 text-center font-semibold">1</td>
              <td className="border px-2 py-1 font-semibold text-orange-700 text-xs">
                {creditStatements.StatementType?.symbol || 'N/A'}
              </td>
              <td className="border px-2 py-1 text-xs">
                {creditStatements.StatementType?.description || 'N/A'}
              </td>
              <td className="border px-2 py-1 font-medium text-xs italic bg-yellow-50">
                {creditStatements.statement || 'No text'}
              </td>
              <td className="border px-2 py-1 text-xs text-gray-600">
                {formatValue('date', creditStatements.Source?.InquiryDate)}
              </td>
              <td className="border px-2 py-1 text-xs">
                {creditStatements.Source?.Bureau?.symbol || 'N/A'}
              </td>
              <td className="border px-2 py-1 text-xs text-gray-500">
                {formatValue('date', creditStatements.dateUpdated) || 'N/A'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  ) : (
    <p className="text-gray-500 text-sm p-4 text-center">No credit statements found</p>
  )}
</div>



            
           


            {/* SCORE FACTORS - Dynamic */}
            {borrower?.CreditScore?.CreditScoreFactor && borrower.CreditScore.CreditScoreFactor.length > 0 && (
              <div className="mt-4">
                <div className="md:text-black p-1 text-black rounded-tr-md rounded-tl-md text-xs border">
                  {formatKey('scoreFactors')}
                </div>
                <table className="min-w-full table-auto border text-left text-[10px]">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-2 py-1 font-semibold text-cyan-500">#</th>
                      {['bureauCode', 'description'].map(header => (
                        <th key={header} className="border px-2 py-1 font-semibold text-cyan-500">
                          {formatKey(header)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {borrower.CreditScore.CreditScoreFactor.map((factor, idx) => {
                      const description = Array.isArray(factor.FactorText) 
                        ? factor.FactorText.find(text => text.startsWith('explain:') || text.startsWith('factor:'))?.replace(/^(explain:|factor:)\s*/, '') || factor.FactorText[0]
                        : factor.FactorText;

                      return (
                        <tr key={idx} className="hover:bg-gray-50">
                          <td className="border px-2 py-1 text-center font-semibold">{idx + 1}</td>
                          <td className="border px-2 py-1 font-semibold">{factor.bureauCode}</td>
                          <td className="border px-2 py-1">{description || 'N/A'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
     

       
          <div className="p-1">
            {/* ADDRESSES - Fully Dynamic */}
            {borrower?.BorrowerAddress && borrower.BorrowerAddress.length > 0 && (
              <div className="mb-4">
                <div className="md:text-black text-black p-1 rounded-tr-xl rounded-tl-xl text-xs font-semibold border">
                  {formatKey('reportedAddresses')}
                </div>

                <table className="min-w-full table-auto border text-left text-[10px]">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-2 py-1 text-cyan-500 cibil-cyan font-semibold">#</th>
                      {['address', 'postalCode', 'region', 'category', 'dateReported'].map(header => (
                        <th key={header} className="border px-2 py-1 text-cyan-500 cibil-cyan font-semibold">
                          {formatKey(header)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {borrower.BorrowerAddress.map((address, idx) => (
                      <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                        <td className="border px-2 py-1 text-center font-semibold">{idx + 1}</td>
                        <td className="border px-2 py-1">
                          {address.CreditAddress?.StreetAddress || 'N/A'}
                          {address.CreditAddress?.City && `, ${address.CreditAddress.City}`}
                        </td>
                        <td className="border px-2 py-1">{address.CreditAddress?.PostalCode || 'N/A'}</td>
                        <td className="border px-2 py-1">{address.CreditAddress?.Region || 'N/A'}</td>
                        <td className="border px-2 py-1">{address.Dwelling?.symbol || 'N/A'}</td>
                        <td className="border px-2 py-1">{formatValue('date', address.dateReported)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* PHONE NUMBERS - Fully Dynamic */}
            {borrower?.BorrowerTelephone && borrower.BorrowerTelephone.length > 0 && (
              <div className="mb-4">
                <div className="md:text-black text-black p-1 rounded-tr-xl rounded-tl-xl text-xs font-semibold border">
                  {formatKey('contactNumbers')}
                </div>

                <table className="min-w-full table-auto border text-left text-[10px]">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border px-2 py-1 text-cyan-500 cibil-cyan font-semibold">#</th>
                      {['telephoneNumber', 'phoneType'].map(header => (
                        <th key={header} className="border px-2 py-1 text-cyan-500 cibil-cyan font-semibold">
                          {formatKey(header)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {borrower.BorrowerTelephone.map((phone, idx) => (
                      <tr key={idx} className={idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                        <td className="border px-2 py-1 text-center font-semibold">{idx + 1}</td>
                        <td className="border px-2 py-1 font-semibold">{phone.PhoneNumber?.Number || 'N/A'}</td>
                        <td className="border px-2 py-1">{phone.PhoneType?.symbol || 'N/A'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* EMPLOYMENT - Fully Dynamic */}
            {borrower?.Employer && (
              <div className="mb-4">
                <div className="md:text-black text-black p-1 rounded-tr-xl rounded-tl-xl text-xs font-semibold border">
                  {formatKey('employmentInformation')}
                </div>

                <div className="border rounded-md overflow-hidden">
                  <div className="grid grid-cols-2 gap-0">
                    {renderDynamicObject(borrower.Employer, ['Source', 'CreditAddress'])}
                  </div>
                </div>
              </div>
            )}
          </div>
   

    
          <div className="p-1">
            <div className="text-black mb-2">
              <h3 className="font-bold text-lg">{formatKey('consumerAccountDetails')}</h3>
              <p className="text-xs text-gray-600">
                {formatKey('totalAccounts')}: {tradeLinePartitions.length}
              </p>
            </div>

            {tradeLinePartitions.map((partition, partIdx) => {
              const tradeline = partition.Tradeline;
              if (!tradeline) return null;

              const { months, history } = buildYearlyHistory(
                tradeline.GrantedTrade?.PayStatusHistory?.MonthlyPayStatus || []
              );

              const { accountKeys, amountKeys, statusKeys } = getTradelineKeys(tradeline);

              return (
                <div key={partIdx} className="mb-2">
                  <span className="text-black text-sm font-semibold mb-1 block">
                    {partIdx + 1}. {formatKey('account')}
                  </span>

                  <div className="border rounded p-2 bg-white shadow-sm">
                 
                    <h5 className="font-semibold bg-gray-100 p-2 text-xs rounded-tl-xl rounded-tr-xl flex flex-wrap gap-x-5 gap-y-1">
                      {Object.entries({
                        type: partition.accountTypeSymbol || tradeline.AccountType?.symbol,
                        creditor: tradeline.creditorName,
                        dateOpened: tradeline.dateOpened,
                        dateClosed: tradeline.dateClosed,
                        dateReported: tradeline.dateReported
                      }).map(([key, value]) => {
                        if (!value) return null;
                        return (
                          <React.Fragment key={key}>
                            <span className="text-cyan-500 cibil-cyan">
                              {formatKey(key)}: <span className="text-black">{formatValue(key, value) || 'Active'}</span>
                            </span>
                            <span className="text-gray-300">|</span>
                          </React.Fragment>
                        );
                      })}
                    </h5>

                   
                    <div className="grid grid-cols-3 md:grid-cols-3 gap-1 text-xs mt-1 p-1">
                      
                      <div className="border-r pr-3">
                        <h3 className="font-bold text-black mb-2 tracking-wide">{formatKey('account').toUpperCase()}</h3>
                        <div className="space-y-1.5">
                          {accountKeys.map(({ key, value }) => (
                            <p key={key}>
                              <span className="font-semibold text-cyan-500 cibil-cyan">{formatKey(key)}:</span>{' '}
                              <span className="text-black">{formatValue(key, value)}</span>
                            </p>
                          ))}
                        </div>
                      </div>

                     
                      <div className="border-r pr-3">
                        <h3 className="font-bold text-black mb-2 tracking-wide">{formatKey('amounts').toUpperCase()}</h3>
                        <div className="space-y-1.5">
                          {amountKeys.map(({ key, value }) => (
                            <p key={key}>
                              <span className="font-semibold text-cyan-500 cibil-cyan">{formatKey(key)}:</span>{' '}
                              <span className={key.toLowerCase().includes('overdue') && value > 0 ? 'text-red-600 font-bold' : 'text-black'}>
                                {formatValue(key, value)}
                              </span>
                            </p>
                          ))}
                        </div>
                      </div>

                    
                      <div className="pl-3">
                        <h3 className="font-bold text-black mb-2 tracking-wide">{formatKey('status').toUpperCase()}</h3>
                        <div className="space-y-1.5">
                          {statusKeys.map(({ key, value }) => (
                            <p key={key}>
                              <span className="font-semibold text-cyan-500 cibil-cyan">{formatKey(key)}:</span>{' '}
                              <span className="text-black">{formatValue(key, value)}</span>
                            </p>
                          ))}
                        </div>
                      </div>
                    </div>

                   
                  
                  {tradeline.GrantedTrade?.PayStatusHistory?.MonthlyPayStatus && 
 tradeline.GrantedTrade?.PayStatusHistory?.MonthlyPayStatus?.length > 0 && (
  <div className="border mt-2 rounded-md overflow-hidden text-xs">
    <div className="flex flex-wrap justify-between px-3 py-2 text-[10px] border-b bg-gray-100">
      <span className="text-sm text-black font-semibold">
        {formatKey('paymentHistory').toUpperCase()}
      </span>
      <p className="text-cyan-500 cibil-cyan">
        {formatKey('start')}: 
        <span className="text-black">
          {formatValue('date', tradeline?.dateOpened)}
        </span>
      </p>
      <p className="text-cyan-500 cibil-cyan">
        | {formatKey('end')}: 
        <span className="text-black">
          {formatValue('date', tradeline?.dateClosed) || 'Active'}
        </span>
      </p>
    </div>

    <div className="overflow-x-auto">
      <table className="w-full text-center border-collapse">
        <thead>
          <tr className="bg-slate-50 border-b">
            <th className="p-1 text-cyan-500 cibil-cyan font-bold">
              {formatKey('year').toUpperCase()}
            </th>
            {months.map((m, idx) => (
              <th key={idx} className="p-1 text-cyan-500 cibil-cyan font-semibold textpx">
                {m}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {Object.keys(history)
            .sort((a, b) => b - a)
            .map((year, yIdx) => (
              <tr key={yIdx} className="border-b hover:bg-gray-50">
                <td className="p-1 font-bold text-cyan-500 cibil-cyan">{year}</td>
                {history[year].map((value, mIdx) => (
                  <td key={mIdx} className="p-1 textpx">
                    <span className={getStatusColor(value)}>
                      {value}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>

    <div className="mt-2 flex flex-wrap gap-3 text-xs bg-gray-50 p-2">
      {[
        { color: 'bg-green-600', label: 'STD - Standard' },
        { color: 'bg-yellow-500', label: '030 - 30 DPD' },
        { color: 'bg-orange-500', label: '060 - 60 DPD' },
        { color: 'bg-red-600', label: '090+ - Default' },
        { color: 'bg-gray-500', label: 'XXX - Not Reported' }
      ].map(({ color, label }) => (
        <div key={label} className="flex items-center gap-1">
          <span className={`w-3 h-3 rounded-full ${color} inline-block`}></span>
          <span className="text-[10px]">{label}</span>
        </div>
      ))}
    </div>
  </div>
)}


                  </div>
                </div>
              );
            })}
          </div>
       


<div className="p-1">
  <div className="text-black mb-2">
    <h3 className="font-bold text-lg">{formatKey('inquiryHistory')}</h3>
    <p className="text-xs text-gray-600">
      Total Inquiries: {getInquiryCount(inquiryPartitions)}
    </p>
  </div>

  {hasInquiries(inquiryPartitions) ? (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto text-left border-collapse text-[10px] whitespace-nowrap">
        <thead className="bg-gray-100 sticky top-0">
          <tr>
            <th className="border px-2 py-1 text-cyan-500 cibil-cyan font-semibold w-8">#</th>
            {['date', 'subscriber', 'amount', 'inquiryTypeCode', 'purposeSymbol', 
              'bureau', 'enqControlNum', 'sourceDate', 'industryDesc'].map(header => (
              <th key={header} className="border px-2 py-1 text-cyan-500 cibil-cyan font-semibold">
                {formatKey(header)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {getAllInquiries(inquiryPartitions).map((inquiry, idx) => (
            <tr key={inquiry.enqControlNum || inquiry.id || idx} 
                className={idx % 2 === 0 ? 'bg-gray-50 hover:bg-gray-100' : 'bg-white hover:bg-gray-100'}>
              
              <td className="border px-2 py-1 text-center font-semibold text-xs">{idx + 1}</td>
              
              {/* Safe nested access with fallbacks */}
              <td className="border px-2 py-1 text-xs">
                {formatValue('date', getInquiryDate(inquiry))}
              </td>
              <td className="border px-2 py-1 font-semibold text-cyan-600 text-xs">
                {get(inquiry, 'subscriberName', 'N/A')}
              </td>
              <td className="border px-2 py-1 text-green-600 font-semibold text-xs">
                {formatValue('amount', get(inquiry, 'amount', '0'))}
              </td>
              <td className="border px-2 py-1 text-xs">
                {get(inquiry, 'inquiryType', 'N/A')}
              </td>
              <td className="border px-2 py-1 text-xs">
                {get(inquiry, 'IndustryCode.symbol', 'N/A')}
              </td>
              <td className="border px-2 py-1 text-xs">
                {get(inquiry, 'Source.Bureau.symbol', 'N/A')}
              </td>
              <td className="border px-2 py-1 font-mono text-xs bg-yellow-50">
                {get(inquiry, 'enqControlNum', 'N/A')}
              </td>
              <td className="border px-2 py-1 text-xs text-gray-600">
                {formatValue('date', get(inquiry, 'Source.InquiryDate', ''))}
              </td>
              <td className="border px-2 py-1 text-xs italic">
                {get(inquiry, 'IndustryCode.description', 'N/A')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="text-center py-8">
      <p className="text-gray-500 text-sm">No inquiries found</p>
      <p className="text-xs text-gray-400 mt-1">
        {CreditReportData ? 'Empty response' : 'Loading...'}
      </p>
    </div>
  )}
</div>


        

       <div className='mt-2'>
  <h3 className="text-green-800 text-center font-bold">
    END of Report: {getConsumerName()}
  </h3>
</div>
      </div>
        {/* FOOTER BUTTONS */}
        <div className="mt-2 p-2 flex justify-center gap-4 border-t no-print">
          <button
            className="bg-cyan-500 text-white px-6 py-2 rounded hover:bg-cyan-700 transition-colors"
            onClick={printReport}
            disabled={isPrinting}
          >
            {isPrinting ? formatKey('printing') : formatKey('printReport')}
          </button>
          <button
            className="bg-red-500 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
            onClick={onClose}
          >
            {formatKey('close')}
          </button>
        </div>
    </div>
  );
};

export default TransUnionReportModal3;